export default function updateUnits(ingredients, units) {
  const ingredientsWithSelectedUnits = ingredients.map((ingredientList) => {
    // if US units
    if (units === 'us') {
      // remove numberMetric and unitMetric to exclude them
      const updatedItems = ingredientList.items.map(({ numberMetric, unitMetric, ...rest }) => rest);
    return { ...ingredientList, items: updatedItems };
    // if metric units
    } else {
      const updatedItems = ingredientList.items.map((item) => {
        // spread numberMetric and unitMetric to exclude them
        const { numberMetric, unitMetric, ...rest } = item;
        if (numberMetric) {
          return { ...rest, number: numberMetric, unit: unitMetric  };
        }
        return item;
      });
      return { ...ingredientList, items: updatedItems };
    }
  })

  return ingredientsWithSelectedUnits;
}